import { useState } from "react";
import PageLayout from "components/layout/PageLayout";
import DateRangePicker from "components/widget/DateRangePicker";
import MonthPicker from "components/widget/MonthPicker";

const AbsenceSettings = () => {

    const [month, setMonth] = useState('2023-07')
    const [isLoading, setLoading] = useState(null)

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async function refresh() {
        setLoading(true)
        await sleep(1000)
        setLoading(false)
    }

    const content = (
        
        <>
            <div className="container">
                <MonthPicker
                    month={month}
                    onMonthPicked={setMonth} />
            </div>

            {month &&
                <div className="container">
                    <h2>Selected Mont: {month}</h2>
                </div>
            }

            <div className="container">
                <DateRangePicker />
            </div>

        </>
    )

    return <PageLayout
        pageTitle={"Settings"}
        isLoadingPage={isLoading}
        onPageRefresh={refresh}
        bodyContent={content}
    />
}

export default AbsenceSettings